{
  "version": 1,
  "asset_id": "91024d23-2891-4548-96bb-09ce2a881f9f",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/91024d23-2891-4548-96bb-09ce2a881f9f/fred-lapides-96.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/91024d23-2891-4548-96bb-09ce2a881f9f/fred-lapides-96.webp",
  "original_filename": "fred-lapides-96.webp",
  "size": 1390,
  "content_type": "image/webp",
  "created_at": "2026-09-18T14:36:53Z"
}
